import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class LegsToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    private readonly simpleLegs = [
        'NDWS',
        'NDGP',
        'NDWP',
        'NDSS',
        'NMWS',
        'NMWP',
    ];
    private readonly frameLegs = [
        'SDGS',
        'SDKS',
        'SDSS',
        'SMDG',
        'SMGS',
    ];
    private readonly skidLegs = [
        'NMGP',
    ];

    public map(element: Element): ISimpleSapElement[] {
        const code = this.toLegsType(element);
        if (this.simpleLegs.includes(code)) {
            return this.getSimpleLegs(code);
        }
        if (this.frameLegs.includes(code)) {
            return this.getFrameLegs(code);
        }
        if (this.skidLegs.includes(code)) {
            return this.getSkidLegs(code);
        }
        return [];
    }

    private getSimpleLegs(code: string): ISimpleSapElement[] {
        const body = this.body;
        const hasSupport = this.hasLegsSupport;
        if (body.shape.x === 2 && hasSupport) {
            const type = this.formatType(code, 5, 3);
            return [SimpleSapElement.LEG(type, '')];
        }
        if (body.shape.x <= 2) {
            const type = this.formatType(code, 1, 3);
            return [SimpleSapElement.LEG(type, '')];
        }
        if (body.shape.x > 2) {
            const type = this.formatType(code, 3, 3);
            return [SimpleSapElement.LEG(type, '')];
        }
        return [];
    }

    private getFrameLegs(code: string): ISimpleSapElement[] {
        let dim1 = this.width;
        const dim2 = this.depth;
        if (dim1 === 2 && this.hasLegsSupport) {
            dim1 = 5;
        }
        const type = this.formatType(code, dim1, dim2);
        const legs = SimpleSapElement.LEG(type, '');
        return [legs];
    }

    private getSkidLegs(code: string): ISimpleSapElement[] {
        const body = this.body;
        const hasSupport = this.hasLegsSupport;
        const dim2 = this.depth;
        if (body.shape.x === 2 && hasSupport) {
            const type = this.formatType(code, 5, dim2);
            return [SimpleSapElement.LEG(type, '')];
        }
        if (body.shape.x <= 2) {
            const type = this.formatType(code, 1, dim2);
            return [SimpleSapElement.LEG(type, '')];
        }
        if (body.shape.x > 2) {
            const type = this.formatType(code, 3, dim2);
            return [SimpleSapElement.LEG(type, '')];
        }
        return [];
    }
}
